import { getPageContent } from 'yoda-interfaces/lib/Order/OrderApi';
import get from 'lodash/get';
import { takeLatest, put, call } from 'redux-saga/effects';
import {
    GET_BNPL_DESCRIPTION,
    SET_BNPL_DESCRIPTION,
    GET_BNPL_DESCRIPTION_FAILED,
} from '../actionTypes/BNPLSectionActionTypes';

function* getBNPLSection(actionParam) {
    const action = actionParam;
    const payload = { pageUrlOrSearchTerm: action.href };
    if (action?.href?.indexOf('cf-bnpl-checkout-content') !== -1) {
        payload.allowMultipleDHTML = true;
    }
    const result = yield call(getPageContent, payload);
    if (result.status === 200) {
        yield put({
            type: SET_BNPL_DESCRIPTION,
            response: get(result, 'data.datas[0].data', undefined),
        });
    } else {
        yield put({
            type: GET_BNPL_DESCRIPTION_FAILED,
            response: get(result, 'data.datas[0].data', undefined),
        });
    }
}

const watchBnplSectionSaga = function* watchBnplSectionSaga() {
    yield takeLatest(GET_BNPL_DESCRIPTION, getBNPLSection);
};

watchBnplSectionSaga.sagaName = 'watchBnplSectionSaga';

export default watchBnplSectionSaga;
